import dayjs, { Dayjs } from "dayjs";
import { z } from "zod";

export const schema = z.object({
    id: z.string(),
    formatted_amount: z.string(),
    result: z.string().min(1, "forms.general-validation.result_required"),
    created_at: z.custom<Dayjs>((value) => dayjs.isDayjs(value), {
        message: "forms.general-validation.must_be_valid_dayjs",
    }),
    updated_at: z.custom<Dayjs>((value) => dayjs.isDayjs(value), {
        message: "forms.general-validation.must_be_valid_dayjs",
    }),
});

export type TransactionReportFormData = z.infer<typeof schema>;
